<template>
    <modal name="cardDeckTutorialModal" :width="1200" height="auto" :maxHeight="1000" :adaptive="true" :scrollable="true">
        <div class="d-flex flex-column h-100 flex-wrap" style="min-height: 864px">
            <div class="card-deck-tutorial__header">
                <button type="button"
                        class="btn-close"
                        data-dismiss="modal"
                        aria-hidden="true"
                        @click="$modal.hide('cardDeckTutorialModal')">
                </button>
            </div>
            <div class="card-deck-tutorial__content row">
                <div class="col-xl-6 mb-2" style="object-fit: contain">
                    <span
                        class="card-deck-tutorial__step">{{ step === 0 ? ('Hello ' +  this.user.name  + '!') : ('Step ' + step + ' of 3') }}</span>
                    <h4 class="card-deck-tutorial__title" v-html="stepData[step].title"></h4>
                    <div class="card-deck-tutorial__description" v-html="stepData[step].description"></div>
                    <img class="img-fluid" :width="step === 0 ? 294 : 161" :src="'/assets/img/logo/' + stepData[step].logo">
                </div>
                <div class="col-xl-6 text-center" >
                    <img class="img-fluid" :src="'/assets/img/tutorial/' + stepData[step].image">
                </div>
            </div>
            <div class="modal-footer">
                <btn v-if="step === 0" class="btn-outline-light btn-lg" @click="$modal.hide('cardDeckTutorialModal')">
                    Not now
                </btn>
                <btn v-else class="btn-outline-light btn-lg" @click="previousStep">Previous</btn>
                <btn v-if="step < 3" class="btn-primary btn-lg" @click="nextStep">
                    {{ step === 0 ? "Let's get started" : "Next tip" }}
                </btn>
                <btn v-else class="btn-primary btn-lg" @click="finish">Got it</btn>
            </div>
        </div>
    </modal>
</template>

<script>
export default {
    name: "CardDeckTutorial",
    props: ['user'],
    data() {
        return {
            step: 0,
            stepData: [
                {
                    title: 'Creating Card Decks Tutorial',
                    description: '<span>A Card Deck is a step-by-step guide for home and community activities. ' +
                        'You can <b>create Card Decks</b> that help Heroes do activities with greater ease and independence!' +
                        '</br></br>I will help you create your first Card Deck. Press <b>"Let\'s get started"</b> to begin.</span>',
                    logo: 'logo_big_hand_wave_primary.svg',
                    image: 'card-deck.png'
                },
                {
                    title: '<div class="flex flex-row align-items-center"><img class="me-1" src="/assets/img/icons/hand-point-right.svg"/><span>Creating Card Decks</span></div>',
                    description: '<span>To create a new Card Deck, tap the "Create a New Card Deck" button  in the top right corner of the dashboard.</br></br>' +
                        'You can also edit existing Card Decks by creating a copy to work with. Simply tap the "Copy Card Deck" button on any Card Deck in \'Your Card Decks\' or \'Community Library\'</span>',
                    logo: 'logo_big_primary.svg',
                    image: 'caregiver-preview.png'
                },
                {
                    title: 'Add photos and text to your Card Deck',
                    description: '<span>A Card Deck is a collection of step-by-step visual, text, and audio instructions.</br></br>' +
                        'Add photos and a text description of each step of the process. Try to use simple words, like the example shows!</br></br>' +
                        'Save photos from your mobile device to your computer to upload to MagnusCards easily.</span>',
                    logo: 'logo_big_primary.svg',
                    image: 'upload-image-example.png'
                },
                {
                    title: 'Share your Card Deck with Heroes',
                    description: '<span>Once your happy with your Card Deck, tap <b>"Create Card Deck"</b>. </br></br>' +
                        'Next, you can share or schedule the Card Deck with Heroes in your network for them to be able to use it.</br></br>' +
                        'To share, tap the <b>"Share with Heroes"</b> button. To schedule the Card Deck in a Hero’s calendar, go to their calendar from a Hero’s profile.</span>',
                    logo: 'logo_big_primary.svg',
                    image: 'share_card_decks.png'
                }
            ]
        }
    },
    created() {
        //TODO display only once per user, after finishing save in db (add column for caregiver - tutorial_completed)
    },
    methods: {
        nextStep() {
            this.step++;
        },
        previousStep() {
            this.step--;
        },
        finish() {
            this.$modal.hide('cardDeckTutorialModal')
            this.step = 0;
            this.$http.post('/user/tutorial-viewed');
        }
    }
}
</script>

<style scoped>

</style>
